// ------------------------------------
// DATA 
// ------------------------------------
// images are imported as base64 strings
import {cityTourCard, easyCityPass, queerCityPass} from "./images.js"

var data = {
  logos:{
    EasyCityPass: easyCityPass,
    QueerCityPass: queerCityPass,
    CityTourCard: cityTourCard,
  },
  shops: {
    EasyCityPass: [
      {
        de: "Berlin",
        en: "Berlin",
        url: "https://shop.easycitypass.com/EasyCityPass/berlin/e-tickets",
        // url: "https://www.getyourguide.de/berlin-l17/berlin-die-stadt-entdecken-mit-dem-easycitypass-t88868/",
        apps: [
          {
            name:"VBB Bus & Bahn",
            logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple123/v4/02/2d/ed/022dedac-3a72-5f05-6a94-95f9693d3dea/AppIcon-0-1x_U007emarketing-0-0-GLES2_U002c0-512MB-sRGB-0-0-0-85-220-0-0-0-8.png/230x0w.png",
            ios: "https://apps.apple.com/de/app/vbb-bus-bahn/id409357982",
            android: "https://play.google.com/store/apps/details?id=de.hafas.android.vbb",
            onelink: "http://onelink.to/7ceb82"
          },{
            name:"BVG Tickets Berlin ",
            logo: "https://is5-ssl.mzstatic.com/image/thumb/Purple113/v4/33/81/fa/3381fa28-e995-07aa-146f-5ee8ceb074c7/AppIcons-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/230x0w.png",
            ios: "https://apps.apple.com/de/app/bvg-tickets-berlin/id1232772818",
            android: "https://play.google.com/store/apps/details?id=de.bvg.ticket",
            onelink: "http://onelink.to/h97jwe"
          },
        ]
      },
      {
        de: "Wien",
        en: "Vienna",
        url: "https://shop.easycitypass.com/EasyCityPass/wien/e-tickets",
        apps: [
          {
            name:"WienMobil",
            logo: "https://is2-ssl.mzstatic.com/image/thumb/Purple123/v4/f4/94/d3/f494d381-561e-0a55-49ad-2294483119a5/AppIcon-0-1x_U007emarketing-0-0-GLES2_U002c0-512MB-sRGB-0-0-0-85-220-0-0-0-10.png/230x0w.png",
            ios: "https://apps.apple.com/at/app/wienmobil/id1107918142",
            android: "https://play.google.com/store/apps/details?id=at.wienerlinien.wienmobillab",
            onelink: "http://onelink.to/rh65qg"
          },
        ]
      },{
        de: "Hamburg",
        en: "Hamburg",
        url: "https://shop.easycitypass.com/EasyCityPass/Hamburg/e-tickets",
        apps: null
      }
    ],
    CityTourCard: [
      {
        de: "München",
        en: "Munich",
        url: "https://shop.easycitypass.com/CityTourCard/Muenchen/e-ticket",
        apps: [
          {
            name:"MVV-App",
            logo: "https://is4-ssl.mzstatic.com/image/thumb/Purple123/v4/f4/d4/ae/f4d4ae05-0a7b-c29e-ae72-fe74561c76e6/AppIcon-0-1x_U007emarketing-0-0-GLES2_U002c0-512MB-sRGB-0-0-0-85-220-0-0-0-3.png/230x0w.png",
            ios: "https://apps.apple.com/de/app/mvv-app/id388686726",
            android: "https://play.google.com/store/apps/details?id=com.mdv.companion",
            onelink: "http://onelink.to/pzhkwk"
          }
//          ,{
//            name:"MVG Fahrinfo München",
//            logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple113/v4/b3/79/03/b37903ef-e7c6-26f9-b3de-28fe164983ef/AppIcon-0-0-1x_U007emarketing-0-0-0-8-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/230x0w.png",
//            ios: "https://apps.apple.com/de/app/mvg-fahrinfo-m%C3%BCnchen/id343701044",
//            android: "https://play.google.com/store/apps/details?id=de.swm.mvgfahrinfo.muenchen",
//            onelink: "http://onelink.to/5wduyn",
//          }
          ,{
            name:"München Navigator",
            logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple113/v4/7b/1d/0d/7b1d0db6-4b5b-d21f-8ff3-8521531d047c/AppIcon-0-1x_U007emarketing-0-0-GLES2_U002c0-512MB-sRGB-0-0-0-85-220-0-0-0-10.png/230x0w.png",
            ios: "https://apps.apple.com/de/app/m%C3%BCnchen-navigator/id453714981",
            android: "https://play.google.com/store/apps/details?id=de.hafas.android.sbm",
            onelink: "http://onelink.to/wrgbcv",
          }
        ]
      },
    ],
    QueerCityPass: [
      {
        de: "Berlin",
        en: "Berlin",
        url: "https://shop.easycitypass.com/QueerCityPass/Berlin/e-tickets",
        // url: "https://sbahn.berlin/tickets/alle-tickets/touristentickets/queercitypass-berlin/?tabs=tbc-t1",
        apps: [
          {
            name:"VBB Bus & Bahn",
            logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple123/v4/02/2d/ed/022dedac-3a72-5f05-6a94-95f9693d3dea/AppIcon-0-1x_U007emarketing-0-0-GLES2_U002c0-512MB-sRGB-0-0-0-85-220-0-0-0-8.png/230x0w.png",
            ios: "https://apps.apple.com/de/app/vbb-bus-bahn/id409357982",
            android: "https://play.google.com/store/apps/details?id=de.hafas.android.vbb",
            onelink: "http://onelink.to/7ceb82"
          },{
            name:"BVG Tickets Berlin",
            logo: "https://is5-ssl.mzstatic.com/image/thumb/Purple113/v4/33/81/fa/3381fa28-e995-07aa-146f-5ee8ceb074c7/AppIcons-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/230x0w.png",
            ios: "https://apps.apple.com/de/app/bvg-tickets-berlin/id1232772818",
            android: "https://play.google.com/store/apps/details?id=de.bvg.ticket",
            onelink: "http://onelink.to/h97jwe"
          },
        ]
      },
      {
        de: "Köln",
        en: "Cologne",
        url: "https://www.bahn.de/p/view/angebot/verbuende/vrs.shtml",
        apps: [
          {
            name:"DB Navigator",
            logo: "https://is4-ssl.mzstatic.com/image/thumb/Purple113/v4/73/f0/99/73f09944-d07f-0fd1-85f1-78f092ed2ab8/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/230x0w.png",
            ios: "https://apps.apple.com/de/app/db-navigator/id343555245",
            android: "https://play.google.com/store/apps/details?id=de.hafas.android.db",
            onelink: "http://onelink.to/jwrk34"
          },
        ]
      },
      {
        de: "Wien",
        en: "Vienna",
        url: "https://shop.easycitypass.com/QueerCityPass/Wien/e-tickets",
        apps: [
          {
            name:"WienMobil",
            logo: "https://is2-ssl.mzstatic.com/image/thumb/Purple123/v4/f4/94/d3/f494d381-561e-0a55-49ad-2294483119a5/AppIcon-0-1x_U007emarketing-0-0-GLES2_U002c0-512MB-sRGB-0-0-0-85-220-0-0-0-10.png/230x0w.png",
            ios: "https://apps.apple.com/at/app/wienmobil/id1107918142",
            android: "https://play.google.com/store/apps/details?id=at.wienerlinien.wienmobillab",
            onelink: "http://onelink.to/rh65qg"
          },
        ]
      },
    ],
  },
  texts: {
    de: {
      // headline per stage
      headline: {
        0: "Welche Stadt möchtest du besuchen?",
        1: "Print Ticket oder mobiles Ticket?",
        2: "Partner App herunterladen"
      },
      // text per stage
      text: {
        0: "",
        1: "Ein Print Ticket als PDF auf dem Handy wird von Verkehrsunternehmen leider nicht als gültig angesehen. Falls du keinen Drucker hast, wähle bitte die mobile Variante.",
        2: "Du kannst ganz bequem ein mobiles Ticket über unsere lokale Partner App kaufen bzw. herunterladen!"
      },
      ticketButtons:{
        mobile: "Mobiles Ticket",
        mobileComingSoon: "Mobiles Ticket: bald erhältlich",
        print: "Ticket zum Drucken"
      },
      backButton: "Zurück",
      triggerButton: "Ticket kaufen"
    },
    en: {
      // headline per stage
      headline: {
        0: "Which City do you want to visit?",
        1: "Print Ticket or mobile ticket?",
        2: "Download Partner App"
      },
      // text per stage
      text: {
        0: "",
        1: "A print ticket as a PDF on the phone is unfortunately not considered valid by public transport companies. If you do not have a printer, please choose the mobile version.",
        2: "You can conveniently buy / download a mobile ticket via our local affiliate app!"
      },
      ticketButtons:{
        mobile: "Mobile Ticket",
        mobileComingSoon: "Mobile Ticket: available soon",
        print: "Print Ticket"
      },
      backButton: "Back",
      triggerButton: "Buy ticket"
    }
  }
}
// generate double entry for munich for easycitypass
data["shops"]["EasyCityPass"].push(data["shops"]["CityTourCard"][0])

export default data
